export default "__VITE_PUBLIC_ASSET__0272596f__"